import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';

export default {
  components: {
    FormGroup,
  },
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    loading: {
      type: Boolean,
    },
    flat: {
      type: Boolean,
    },
  },
  computed: {
    payload() {
      return this.value;
    },
    isLoading() {
      return this.loading;
    },
    isFlat() {
      if (typeof this.getCardFlat === 'boolean') {
        return this.getCardFlat;
      }
      return this.flat;
    },
    getCardFlat() {
      return this.analysisTable.cardFlat;
    },
    compareUserData() {
      return [
        this.payload.dataByUser,
        this.payload.dataByOcr,
        this.payload.dataByBigData,
      ];
    },
  },
  inject: {
    analysisTable: {
      default() {
        return {
          cardFlat: '',
          clientInfo: {
            loading: '',
          },
          page: {
            reloadInfo: (v) => v,
            reloadPhotos: (v) => v,
            reloadPage: (v) => v,
          },
        };
      },
    },
  },
};
